<template>
  <div class="yxtbiz-skill-viewer">
    <SkillViewer
      v-bind="$attrs"
      :skills="newList"
      child-key="skillModelMaps"
      :legends="legends"
      :radius="previewRadius"
      :axis="previewAxis"
      :options="radarOption"
      :show-skill-level="enableSkillLevel"
      :enable-weight-switch="enableWeightSwitch"
      :enable-excellent-level="enableExcellentLevel"
      :checkbox="checkbox"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import SkillViewer from './components/skillViewer';
import { formatDataRadar } from './utils';

export default {
  name: 'YxtbizSkillViewer',
  components: { SkillViewer },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    enableSkillLevel: {
      type: [Boolean, Number],
      default: true
    },
    enableWeightSwitch: {
      type: Number,
      default: 0
    },
    enableExcellentLevel: {
      type: Number,
      default: 0
    },
    radarOption: {
      type: Object,
      default: () => {
        return {
          height: 242,
          padding: [5, 0, 5, 0]
        };
      }
    },
    radius: {
      type: Number
    }
  },
  data() {
    return {
      newList: []
    };
  },
  computed: {
    legends() {
      const skillArr = [
        {
          props: {
            hoverLevelProp: 'standardLevelName',
            hoverValueProp: 'combinedStdLevelStr'
          },
          name: 'combStandardLevel',
          label: this.$t('pc_gwnl_training_legend_standard'),
          color: '#4943FF',
          selected: true,
          disabled: false,
          show: true
        },
        this.enableExcellentLevel && {
          props: {
            hoverLevelProp: 'combExcellentLevelName',
            hoverValueProp: 'excellentScore'
          },
          name: 'excellentEavl',
          label: this.$t('pc_gwnl_f2f_mark_excellent'),
          color: '#e59425',
          selected: true,
          disabled: false,
          show: true
        }
      ];
      return this.enableSkillLevel ? skillArr.filter(Boolean) : [];
    },
    previewRadius() {
      return this.radius ? this.radius : this.list.length === 3 ? 0.6 : 0.8;
    },
    previewAxis() {
      return {
        labelLength: this.list.length === 3 ? 5 : 10
      };
    },
    checkbox() {
      return this.enableExcellentLevel === 1;
    }
  },
  watch: {
    list: {
      immediate: true,
      handler(val) {
        this.newList = formatDataRadar(val, 'skillModelClassifications', this.enableWeightSwitch);
      }
    }
  }
};
</script>
